import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react'
import { useDispatch, batch } from 'react-redux'

import Loading from '../components/Loading'
import Profile from '../components/Profile'

import { useTrailProfile, useSteps } from '../api'
import { setMapView, setMapPin } from '../slices/map'
import { setProfilePin, useProfilePin } from '../slices/profile'
import { useUserPosition, useUserIsOnTrail } from '../slices/userposition'
import { wordwrap } from '../utils'
import { isTouchDevice } from '../utils'

const TrailProfile = (props) => {
  const { route_id, trail_id, compact, unit, speed } = props
  const dispatch = useDispatch()
  const [data, setData] = useState({marker:null, profile: null})
  const trailProfile = useTrailProfile({ routeId: route_id, trailId: trail_id }, {skip: !trail_id, keepOld: !trail_id})
  const steps = useSteps({ routeId: route_id, trailId: trail_id }, {skip: !trail_id, keepOld: !trail_id})
  const userPosition = useUserPosition()
  const userIsOnTrail = useUserIsOnTrail()
  const pin = useProfilePin() 
  const resetPinOnTouch = useRef()
  const isLoading = trail_id && (!trailProfile || !steps)
  const userPin = (userPosition && userIsOnTrail) ? [userPosition.distance, userPosition.elevation, userPosition.time] : null

  useEffect(()=>{
    if (!trailProfile || !steps) return
    const markers = steps
      .filter(x => !x.is_deviation)
          .sort((a, b) => (a.relevance > b.relevance) ? 1 : -1)
          .map(x => ({
            distance: x.length,
            elevation: x.elevation_on_trail,
            time: x.time,
            label: wordwrap(x.title)
          }))
   
    setData({
        markers: markers,
        profile: trailProfile,
        suggestedMax: unit == 'm' ? [20000, 800] : [12, 2500]
    })
  }, [steps, trailProfile, unit])

  const moveHandler = useCallback((e) => {
    const { lnglat, distance, elevation, time } = e
    batch(() => {
      dispatch(setProfilePin([distance, elevation, time]))
      dispatch(setMapPin(lnglat))
    })
  }, [dispatch])

  const outHandler = useCallback((e) => {
    batch(() => {
      dispatch(setProfilePin(null))
      dispatch(setMapPin(null))
    })
  }, [dispatch])

  const clickHandler = useCallback((e) => {
    const { lnglat, distance, elevation, time } = e
    batch(() => {
      dispatch(setProfilePin([distance, elevation, time]))
      dispatch(setMapPin(lnglat))
      dispatch(setMapView({lnglat: lnglat, zoom: 12}))
    })
    if (isTouchDevice){
      clearTimeout(resetPinOnTouch.current)
      resetPinOnTouch.current = setTimeout(()=>{
          batch(()=>{
            dispatch(setProfilePin(null))
            dispatch(setMapPin(null))
          })
      }, 10000)
    }
  }, [dispatch])

  return (
    <>
      { isLoading && <Loading/> }
      <Profile markers={data.markers} 
               profile={data.profile} 
               unit={unit}
               speed={speed}
               pin={pin}
               userPosition = {userPin}
               compact={compact} 
               suggestedMax={data.suggestedMax}
               onMouseMove={isTouchDevice ? null : moveHandler}
               onMouseOut={isTouchDevice ? null : outHandler}
               onClick={clickHandler}/>
    </>
  )
}

export default TrailProfile
